import Show from '../../../Show/Show';
import { FC } from 'react';
import {
  H3,
  ParagraphMRegular,
} from '../../../../config/designSystem/typography';
import { QuestionSessionBodyPresentationProps } from '../config';
import { StyleSheet, View } from 'react-native';
import { observer } from 'mobx-react';

const _PresentPhoneNumber: FC<QuestionSessionBodyPresentationProps> = ({
  questionDescription,
  questionText,
  margin,
}) => {
  return (
    <>
      <Show when={questionText}>
        <View
          style={[{ marginHorizontal: margin }, styles.questionText]}
        >
          <H3 selectable={true}>
            {questionText}
          </H3>
        </View>
      </Show>
      <Show when={questionDescription}>
        <View
          style={[{ marginHorizontal: margin }, styles.questionDescription]}
        >
          <ParagraphMRegular selectable={true} align={true}>
            {questionDescription}
          </ParagraphMRegular>
        </View>
      </Show>
    </>
  );
};
export const PresentPhoneNumber = observer(_PresentPhoneNumber);

const styles = StyleSheet.create({
  questionText: {
    marginBottom: 16,
    marginTop: 8,
    alignContent: 'center',
    alignItems: 'center',
  },
  questionDescription: {
    marginBottom: 32,
    marginTop: 8,
    alignContent: 'center',
    alignItems: 'center',
  },
});
